import { ds24_get_cookie, ds24_set_cookie } from "../common/ds24_cookie";

export function ds24cart_id( new_cart_id?: string )
{
    if (typeof new_cart_id != 'undefined' && new_cart_id)
    {
        window.digistore24_cart_id = new_cart_id;
    }
    if (typeof window.digistore24_cart_id == 'undefined')
    {
        window.digistore24_cart_id = '';
    }

    if (!window.digistore24_cart_id) {
        window.digistore24_cart_id = ds24_get_cookie( 'ds24cart_id' );
    }

    if (window.digistore24_cart_id)
    {
        ds24_set_cookie( 'ds24cart_id', window.digistore24_cart_id, 7 );
    }

    return window.digistore24_cart_id;
}
